import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	title: {
		fontWeight: 600,
		fontSize: "1.35rem",
		letterSpacing: "-0.02em",
		color: theme.palette.text?.primary || (theme.mode === "light" ? "#0f172a" : "#f1f5f9"),
		marginBottom: theme.spacing(0.5),
	},
}));

export default function Title(props) {
	const classes = useStyles();

	return (
		<Typography variant="h5" className={classes.title} gutterBottom>
			{props.children}
		</Typography>
	);
}
